import { IconArrow } from 'components/Shared/Icon/themes/BGH-RD3/iconArrow';
import { FilterButton } from '../filterButton';
import cn from 'classnames';
import styles from './dropdownButton.scss';

interface DropdownButtonProps {
  onClick: () => void;
  shouldClose: boolean;
  displayName: string;
  isFilterActive?: boolean;
  isSortButton?: boolean;
  isDropdown?: boolean;
  className?: string;
}

export const DropdownButton = ({
  onClick,
  shouldClose,
  displayName,
  isSortButton,
  isDropdown = true,
  isFilterActive,
  className
}: DropdownButtonProps) => {
  const [name, unit] = displayName.split('(');

  return (
    <div
      className={cn({
        [styles.customButtonMargin]: !isSortButton,
        [styles.sortButton]: isSortButton
      })}
    >
      <FilterButton
        isDropdown={isDropdown}
        shouldClose={shouldClose}
        isSortButton={isSortButton}
        isFilterActive={isFilterActive}
        className={cn(styles.dropdownButton, className)}
        onClick={onClick}
        title={displayName}
      >
        {name}
        {unit && <span className={styles.unit}>({unit}</span>}
        {isDropdown && (
          <IconArrow
            size="small"
            appearance={shouldClose ? 'flip-270' : 'flip-90'}
            className={styles.filterArrow}
          />
        )}
      </FilterButton>
    </div>
  );
};
